export default "__VITE_ASSET__Bo8BAU05__"